/**
 * Common constants used across the application
 */

/**
 * Available practice area options for lawyers
 * Note: "Other" option has been removed - only standard practice areas are available
 */
export const PRACTICE_AREA_OPTIONS = [
  'Bankruptcy/Debt Collection ',
  'Business/Corporate',
  'Civil Disputes',
  'Criminal Law',
  'Disability Law',
  'Education Law',
  'Elder Law',
  'Estate Planning, Wills & Trusts',
  'Family Law',
  'Government Benefits',
  'Immigration',
  'Juvenile Law',
  'Property/Real Estate',
] as const;

/**
 * US States list (including DC)
 * Used for state selection in forms and filters
 */
export const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','DC'
] as const;

/** Security-safe copy: same wording whether or not a passcode was actually sent (lawyer edit flow). */
export const EDIT_PASSCODE_REQUEST_SUCCESS_MESSAGE =
  'If an account with this email exists and is verified, a passcode has been sent. Redirecting to passcode entry...';

export const EDIT_PASSCODE_ENTRY_DESCRIPTION =
  'If an account with this email exists and is verified, a passcode has been sent. Enter it below when you receive it.';

/** Security-safe copy: same wording whether or not an edit token was actually sent (agency edit flow). */
export const EDIT_TOKEN_REQUEST_SUCCESS_MESSAGE =
  'If an account with this email exists and is verified, a passcode has been sent. Redirecting...';

export const EDIT_TOKEN_ENTRY_DESCRIPTION =
  'If an account with this email exists and is verified, a passcode has been sent. Enter it below when you receive it.';

